<template>
  <div id="app">
    <header-view />
    <router-view />
  </div>
</template>

<script>
import HeaderView from '@/components/Header.vue';

export default {
  name: 'App',
  components: {
    HeaderView
  },
  mounted() {
    this.setAppLocale();
  },
  methods: {
    getBrowserLocale(options = { countryCodeOnly: true }) {
      const navigatorLocale = navigator.languages !== undefined
        ? navigator.languages[0]
        : navigator.language;

      if (!navigatorLocale) {
        return undefined;
      }

      return options.countryCodeOnly
        ? navigatorLocale.split('-')[0]
        : navigatorLocale;
    },
    setAppLocale() {
      const availableLocales = this.$i18n.availableLocales;
      const savedLocale = localStorage.getItem('app-locale');
      const browserLocale = this.getBrowserLocale({ countryCodeOnly: true });

      const localeToSet = savedLocale
        || (availableLocales.includes(browserLocale) ? browserLocale : 'en');

      this.$i18n.locale = localeToSet;
    }
  }
};
</script>

<style scoped>
#app {
  position: relative;
}
</style>
